import { createContext, useContext } from 'react';
import { app } from '@microsoft/teams-js';

export interface IAppContextProps {
    teamsContext: app.Context;
}

export const AppContext = createContext<IAppContextProps>(undefined!);
export const useAppContext = () => useContext<IAppContextProps>(AppContext);
